import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propChildren, propFunc, propId, } from '../../../../../../../helpers/custom-prop-types';
const AccountTableCheckBox = (props) => {
    const { checked, children, disabled, onChange, value } = props;
    return (_jsxs("label", Object.assign({ className: 'account_table_check_box slide_checkbox' }, { children: [_jsx("input", { checked: checked, className: 'item_checkbox', disabled: disabled, onChange: onChange, type: 'checkbox', value: value }), _jsx("div", { className: 'item_checkbox_label' }), children] })));
};
AccountTableCheckBox.propTypes = {
    checked: propBool().isRequired,
    children: propChildren(),
    disabled: propBool().isRequired,
    onChange: propFunc().isRequired,
    value: propId().isRequired,
};
AccountTableCheckBox.defaultProps = {
    children: null,
};
export default AccountTableCheckBox;
